var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex responsive-image"},[_c('div',{staticClass:"thumbnail",style:({
      backgroundImage: ("url(" + (_vm.getProductImageLowRes(
        _vm.product.imageSources[0],
        _vm.product.store
      )) + ")")
    })},[_c('img',{staticClass:"img",attrs:{"id":"img","sizes":"(max-width: 767px) calc(50vw - 36px), (min-width: 768px) and (max-width: 1280px) calc(25vw - 64px), 284px","src":("" + (_vm.getProductImageLowRes(_vm.product.imageSources[0], _vm.product.store)))},on:{"error":_vm.imageError}})])])}
var staticRenderFns = []

export { render, staticRenderFns }